var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCornerUpRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7691 4.1809C17.0103 3.9397 17.4014 3.9397 17.6426 4.1809L23.8191 10.3574C24.0603 10.5986 24.0603 10.9897 23.8191 11.2309L17.6426 17.4073C17.4014 17.6485 17.0103 17.6485 16.7691 17.4073C16.5279 17.1661 16.5279 16.7751 16.7691 16.5338L21.8912 11.4118H8.55882C7.41215 11.4118 6.31245 11.8673 5.50163 12.6781C4.69081 13.4889 4.23529 14.5886 4.23529 15.7353V24.3824C4.23529 24.7235 3.95876 25 3.61765 25C3.27653 25 3 24.7235 3 24.3824V15.7353C3 14.261 3.58566 12.8471 4.62814 11.8046C5.67062 10.7621 7.08453 10.1765 8.55882 10.1765H21.8912L16.7691 5.05439C16.5279 4.81318 16.5279 4.42211 16.7691 4.1809Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCornerUpRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/corner-up-right.a78550d2.svg";
export { ForwardRef as ReactComponent };